import { useState, useEffect } from "react";
import RaceDetailPC from "./pc";
import RaceDetailMobile from "./mobile"; 
import { useMyContext } from '@/app/utils/MyContext';
import _ from 'lodash';
import { useLanguage } from "@/app/utils/LanguageContext";
import { Skeleton, SxProps, Theme } from "@mui/material";
import NoInformation from "@/app/ui/Common/NoInformation";
import Loading from "@/app/[language]/overseas/loading";
import Box from "@mui/material/Box";

interface propType {
  isMobile?: boolean;
  meetings: IMeeting[];
  onTips2Dismiss?: ()=>void;
  clickTipOnly?: boolean;
  showTips2?: any;
  showTips1?: any;
  onTips1Dismiss?: ()=>void;
  setRacesDetailLoading: (loading: boolean) => void;
  isLoadingRacesDetail: boolean;
}

const RaceDetail: React.FC<propType> = ({ isMobile = false, meetings,clickTipOnly,showTips1,onTips1Dismiss, showTips2,onTips2Dismiss, setRacesDetailLoading, isLoadingRacesDetail }) => {
  const { state: lang } = useLanguage();
  const { t } = lang;
  const [meetingSummaryMenu, setMeetingSummaryMenu] = useState<any>(null);
  const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
  useEffect(() => {
    if(myContextState.selectedMeeting) { 
      setMeetingSummaryMenu(myContextState.selectedMeeting?.MeetingSummaryMenu?.targetItems);
    }
  }, [myContextState.selectedMeeting]);

  return myContextState.selectedMeeting ? (
    isMobile ? <RaceDetailMobile clickTipOnly={clickTipOnly} showTips1={showTips1} onTips1Dismiss={onTips1Dismiss} showTips2={showTips2} onTips2Dismiss={onTips2Dismiss} meetings={meetings} menuData={meetingSummaryMenu} setRacesDetailLoading={setRacesDetailLoading} isLoadingRacesDetail={isLoadingRacesDetail} /> : <RaceDetailPC meetings={meetings} menuData={meetingSummaryMenu} setRacesDetailLoading={setRacesDetailLoading} isLoadingRacesDetail={isLoadingRacesDetail} />
  ) : myContextState.isLoadingRaces &&
   raceDetailSkeleton(isMobile, isMobile ? {marginTop: '5px'} : {marginTop: '15px'});
};

// export const raceDetailSkeleton = (isMobile: boolean, sx?: SxProps<Theme>) => <Skeleton variant="rounded" height={isMobile ? 300 : 450} sx={sx} />
export const raceDetailSkeleton = (isMobile: boolean, sx?: SxProps<Theme>) => (<Box sx={{ height: isMobile ? 300 : 450, ...sx }}><Loading /></Box>)

export default RaceDetail;
